namespace GeniuzPOS.InitialData {
    export interface PsDiscCouponTypeItemRow {
        Id?: number;
        DiscCouponType?: string;
        ListFg?: number;
        PluCode?: string;
        StyleCode?: string;
        CatCode?: string;
        SubCat1Code?: string;
        SubCat2Code?: string;
        BrandCode?: string;
        SupplCode?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        UpdateDate?: string;
    }

    export namespace PsDiscCouponTypeItemRow {
        export const idProperty = 'Id';
        export const nameProperty = 'DiscCouponType';
        export const localTextPrefix = 'InitialData.PsDiscCouponTypeItem';
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทคูปองส่วนลด:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทคูปองส่วนลด:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทคูปองส่วนลด:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทคูปองส่วนลด:Modify';

        export declare const enum Fields {
            Id = "Id",
            DiscCouponType = "DiscCouponType",
            ListFg = "ListFg",
            PluCode = "PluCode",
            StyleCode = "StyleCode",
            CatCode = "CatCode",
            SubCat1Code = "SubCat1Code",
            SubCat2Code = "SubCat2Code",
            BrandCode = "BrandCode",
            SupplCode = "SupplCode",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            UpdateDate = "UpdateDate"
        }
    }
}
